import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {PriceLevelAuditReportModel} from "./price-level-audit-report.model";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";

@Component({
    selector: "wbo-price-level-audit-report",
    templateUrl: "./price-level-audit-report.component.html",
    providers: [provideReportModel(PriceLevelAuditReportModel)]
})
export class PriceLevelAuditReportComponent extends AbstractReportPage {
    constructor(public model: PriceLevelAuditReportModel) {
        super();
    }
}
